interface SchemaField {
  key: string;
  type: string;
  itemSchema?: SchemaField[];
  itemType?: string;
  schema?: SchemaField[];
  valueSchema?: SchemaField[];
}

function arrayToObject(arr: any[], schema: SchemaField[]): any {
  const obj: any = {};
  let idx = 0;
  
  for (const field of schema) {
    if (idx >= arr.length) break;
    
    const key = field.key.includes(".") ? field.key.split(".").pop()! : field.key;
    const value = arr[idx++];
    
    if (value === null || value === undefined) {
      continue;
    }
    
    if (field.type === "array") {
      if (field.itemSchema) {
        obj[key] = value ? value.map((item: any[]) => arrayToObject(item, field.itemSchema!)) : null;
      } else {
        obj[key] = value;
      }
    } else if (field.type === "dynamic") {
      if (Array.isArray(value) && value.length > 0) {
        if (field.valueSchema) {
          obj[key] = Object.fromEntries(value.map(([k, v]: [string, any[]]) => [k, arrayToObject(v, field.valueSchema!)]));
        } else {
          obj[key] = Object.fromEntries(value);
        }
      } else {
        obj[key] = {};
      }
    } else if (field.type === "object") {
      obj[key] = value ? arrayToObject(value, field.schema!) : null;
    } else {
      obj[key] = value;
    }
  }
  
  return obj;
}

export function decompressJsonData(data: any): any {
  if (data._format === "array" && data._schema && Array.isArray(data.results)) {
    return {
      totalMatches: data.totalMatches,
      generatedAt: data.generatedAt,
      results: data.results.map((arr: any[]) => arrayToObject(arr, data._schema)),
    };
  }
  
  return data;
}
